module.exports = __webpack_public_path__ + "img/叶坪红军检阅台.54381f52.png";